import { ScriptRepositoryComponent } from './script-repository/script-repository.component';
import { CommonModule } from "@angular/common";
import { Component, ElementRef, ViewChild, Input, OnInit, Renderer2, TemplateRef } from '@angular/core';
import { first } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { User } from 'src/app/models/user';
import { AccessTokenService } from 'src/app/services/access-token.service';
import { AutomationService } from 'src/app/services/automation.service';
import { LoginService } from 'src/app/services/login.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { WebSocketService } from 'src/app/services/websocket-appium.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { CommonService } from 'src/app/services/common.service';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-automation',
  templateUrl: './automation.component.html',
  styleUrls: ['./automation.component.css'],
  standalone: true,
  imports: [TranslateModule, FormsModule, CommonModule, ScriptRepositoryComponent]
})
export class AutomationComponent implements OnInit {
  @ViewChild('capsModalTemplate') capsModalTemplate!: TemplateRef<any>;
  capsDialogRef: any;
  baseUrl = environment.baseUrl;
  @ViewChild('alerttemplate') alertTemplate!: TemplateRef<any>;
  @ViewChild('alerttemplate1') alertTemplate1!: TemplateRef<any>;
  showAppiumAlert: boolean = false;
  alertShow: boolean = false;
  msg: string = "";
  msg1: string = "";
  currentUser: User;
  // @Input() control:ControlService;
  isAppInspector: boolean = false;
  @Input() device: any;
  @ViewChild('urlInputField') urlInputField!: ElementRef<HTMLInputElement>;
  @ViewChild('paragraphElement') paragraphElement: any;
  urlValue: string = '';
  bridgeHost: any;
  appiumPort: any;
  bH: any;
  Token: any;
  appInspectorPort: any;
  appInspectorUrl: any;
  demoScript: any;
  packageName: any;
  appiumInspectorUrl: any;
  modalRef!: MatDialogRef<any>;
  activityName: string = '';
  constructor(
    private websocket: WebSocketService,
    private automationService: AutomationService,
    private loginService: LoginService,
    private renderer: Renderer2,
    private accessTokenService: AccessTokenService,
    private clipboard: Clipboard,
    private dialog: MatDialog,
    private router: Router,
    private http: HttpClient,
    private commonService: CommonService
  ) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit() {
    window.onbeforeunload = null;

    if (sessionStorage.getItem("appiumPort") != null) {
      this.appiumPort = sessionStorage.getItem("appiumPort");
    } else {
      this.appiumPort = null;
    }

    this.appInspectorPort = null;
    if (sessionStorage.getItem("appInspectorUrl") != null && sessionStorage.getItem("appInspectorUrl") != "null") {
      this.appInspectorUrl = sessionStorage.getItem("appInspectorUrl");
    } else {
      this.appInspectorPort = null;
      this.appInspectorUrl = null;
    }

    this.bridgeHost = this.device.providerUrl;
    this.bH = this.bridgeHost;
    this.demoScript = '';
    this.packageName = "";
    this.appiumInspectorUrl = '';
    //for new backend
    this.getAccessToken();
    this.activeSubTab = "config";
  }

  getAccessToken() {

    this.accessTokenService.displayTokenKey(this.currentUser.email).subscribe((response: any) => {
      this.Token = response.tokens[0];

    })
    // this.automationService.displayOfAccessTokenOfUser(this.currentUser.email).subscribe((res: any) => {
    //   console.log("<<<<<>>>" + res.data)
    //   this.Token = res.data;
    // });
  }

  getPackageName() {
    this.automationService.getPackageName(this.bridgeHost, this.device.serial).pipe(first()).subscribe((res: any) => {
      if (this.device.ios) {
        this.packageName = res.packageName;
        this.msg = "Bundle ID: " + res.packageName;
      } else {
        // Fix: Use correct property names from API response
        this.packageName = res.appPackage;  // Changed from res.packageName
        this.activityName = res.appActivity; // Added missing assignment
        this.msg = "Package Name: " + res.appPackage;
        this.msg1 = "Activity Name: " + res.appActivity;
      }
    });
  }

  appiumInspector() {
    this.isAppInspector = !this.isAppInspector;

    let data =
      // your data objects
      [
        {
          "type": "text",
          "name": "platformName",
          "value": this.device.platform
          // "value": "Android"
        },
        {
          "type": "text",
          "name": "appium:automationName",
          "value": this.device.platform === "Android" ? "uiautomator2" : "XCUITest"
          // "value": "uiautomator2"
        },
        {
          "type": "text",
          "name": "appium:platformVersion",
          "value": this.device.version
          // "value": "8.0.0"
        },
        {
          "type": "text",
          "name": "appium:deviceName",
          "value": this.device.serial
          // "value": "e04ce08c"
        },
        {
          "type": "text",
          "name": "appium:udid",
          "value": this.device.serial
          // "value": "e04ce08c"
        },
        {
          "type": "text",
          "name": "appium:apmosys.user",
          "value": this.device.owner?.email
          // "value": "admin@apmosys.com"
        },
        {
          "type": "text",
          "name": "appium:apmosys.accessToken",
          "value": this.Token
          // "value": "064c0ce695ab411ca36066f010d1c82c30acd9aa62bb4e0388c282d94d34d3ff"
        }
      ];

    // Connect to the WebSocket server
    this.websocket.connect(this.baseUrl + '/inspectSocket/');

    FingerprintJS.load().then((fp) => {
      fp.get().then((result) => {
        const uniqueId = result.visitorId;
        // Send `this.bridgeHost` after 1000ms
        setTimeout(() => {
          const bridgeHostMessage = {
            type: "Appium URL",
            id: uniqueId,
            value: this.bridgeHost,
          };
          this.websocket.sendMessage(bridgeHostMessage);
        }, 3000);

        // Send `data` as message with type "capsArray" after 3000ms
        setTimeout(() => {
          const capsArrayMessage = {
            type: "capsArray",
            id: uniqueId,
            value: data,
          };
          this.websocket.sendMessage(capsArrayMessage);
        }, 5000);
      }).catch((error) => {
        console.error('Error retrieving fingerprint ID:', error);
      });
    }).catch((error) => {
      console.error('Error loading FingerprintJS:', error);
    });

    // Open the Appium Inspector
    window.open(this.baseUrl + '/inspector/');
  }

  copyCapabilities(textToCopy: string) {
    this.clipboard.copy(textToCopy);

    // Optionally, provide some feedback to the user
    this.msg = "Desired capabilities has been copied to clipboard";
    this.alertShow = true;
    this.openAlertMod(this.alertTemplate, this.msg);
  }

  copyPackageName() {
    if (this.packageName) {
      this.clipboard.copy(this.packageName);
      this.msg = "Package name has been copied to clipboard";
      this.alertShow = true;
      this.openAlertMod(this.alertTemplate, this.msg);
    } else {
      this.msg = "No package name available. Please get package information first.";
      this.openAlertMod(this.alertTemplate, this.msg);
    }
  }

  copyActivityName() {
    if (this.activityName) {
      this.clipboard.copy(this.activityName);
      this.msg = "Activity name has been copied to clipboard";
      this.alertShow = true;
      this.openAlertMod(this.alertTemplate, this.msg);
    } else {
      this.msg = "No activity name available. Please get package information first.";
      this.openAlertMod(this.alertTemplate, this.msg);
    }
  }

  copyBundleId() {
    if (this.packageName && this.device.ios) {
      this.clipboard.copy(this.packageName);
      this.msg = "Bundle ID has been copied to clipboard";
      this.alertShow = true;
      this.openAlertMod(this.alertTemplate, this.msg);
    } else if (!this.device.ios) {
      this.msg = "Bundle ID is only available for iOS devices";
      this.openAlertMod(this.alertTemplate, this.msg);
    } else {
      this.msg = "No bundle ID available. Please get package information first.";
      this.openAlertMod(this.alertTemplate, this.msg);
    }
  }

  clickOnkeyboard(Appiumurl: any) {
    this.clipboard.copy(Appiumurl)
    this.msg = "URL copied to clipboard: " + Appiumurl;
    this.openAlertMod(this.alertTemplate, this.msg);
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = '';
    }, 2000)
  }

  //here setTimeout is not implemented so the user has enough time to copy the required packages
  openAlertMod1(template: TemplateRef<any>, message: any, message1: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    this.msg1 = message1;
  }

  openAlertMod2(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
  }

  Ok() {
    this.modalRef.close();;
    this.msg = "";
  }


  downloadFile() {

    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', 'assets/documents/Automation Document.pdf');
    link.setAttribute('download', 'Automation_Document.pdf');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  routeToInspector() {
    this.showAppiumAlert = true;
    let payloadAppiumSession = {
      "capabilities": {
        "alwaysMatch": {
          "platformName": this.device.platform,
          "appium:automationName": this.device.platform === 'Android' ? 'uiautomator2' : 'XCUITest',
          "appium:platformVersion": this.device.version,
          "appium:deviceName": this.device.serial,
          "appium:udid": this.device.serial,
          "appium:apmosys.user": this.device.owner?.email,
          "appium:apmosys.accessToken": this.Token,
          "appium:ensureWebviewsHavePages": true,
          "appium:nativeWebScreenshot": true,
          "appium:newCommandTimeout": 3600,
          "appium:connectHardwareKeyboard": true
        },
        "firstMatch": [
          {}
        ]
      },
      "desiredCapabilities": {
        "platformName": this.device.platform,
        "appium:automationName": this.device.platform === 'Android' ? 'uiautomator2' : 'XCUITest',
        "appium:platformVersion": this.device.version,
        "appium:deviceName": this.device.serial,
        "appium:udid": this.device.serial,
        "appium:apmosys.user": this.device.owner?.email,
        "appium:apmosys.accessToken": this.Token,
        "appium:ensureWebviewsHavePages": true,
        "appium:nativeWebScreenshot": true,
        "appium:newCommandTimeout": 3600,
        "appium:connectHardwareKeyboard": true
      }
    };
    let providerUrl = this.device.providerUrl;
    sessionStorage.setItem("providerUrl", providerUrl);
    sessionStorage.setItem("payloadAppiumSession", JSON.stringify(payloadAppiumSession));
    console.log('providerUrl before the request of session: ', providerUrl);

    this.http.post(providerUrl + '/session', payloadAppiumSession).subscribe({
      next: (response: any) => {
        console.log("Appium Session Created: ", response);

        if (response?.value?.sessionId) {
          sessionStorage.setItem("appiumSessionId", response.value.sessionId);
          this.commonService.setActiveTab('/inspector/');
          this.router.navigate(['/inspector', this.device?.serial, response.value.sessionId]);
          this.showAppiumAlert = false;
        } else {
          this.showAppiumAlert = false;
          this.msg = response?.value?.message || "Failed to create Appium session. Please try again.";
          this.openAlertMod2(this.alertTemplate, this.msg);
        }
      },

      error: (error) => {
        console.error("Appium Session Error: ", error);

        this.showAppiumAlert = false;

        // Extract meaningful message
        let errorMsg = "Something went wrong while creating Appium session.";

        if (error?.status === 500) {
          errorMsg = error?.error?.value?.message || "Internal Server Error (Appium)";
        } else if (error?.status === 404) {
          errorMsg = "Appium server endpoint not found.";
        } else if (error?.status === 0) {
          errorMsg = "Unable to reach Appium server. Check network or URL.";
        } else if (error?.error?.value?.message) {
          errorMsg = error.error.value.message;
        }

        this.msg = errorMsg;
        this.openAlertMod2(this.alertTemplate, this.msg);
      },

      complete: () => {
        console.log("Appium session request completed");
      }
    });
  }

  // === UI & Repository State ===
  activeSubTab: string = 'config'; 
            
  setActiveSubTab(tab: string) {
    this.activeSubTab = tab;
  }

}
